<div class=" space-y-4 md:hidden">
  <div class="space-y-2">
    <div>
      <app-select label="Price Level" (selectedChange)="setPriceLevel($event)" [selected]="resultsStore.currentPriceLevel()?.id?.toString() || ''" [options]="priceLevels()"></app-select>
    </div>

    <app-select label="Sort" (selectedChange)="toggleSort($event)" [selected]="resultTableService.sortConfig().field ?? ''" [options]="sortOptions()"></app-select>
  </div>

  <div class=" border-b border-gray-200 dark:border-gray-700 mb-2" style="margin-left: -10px; margin-right: -10px"></div>
</div>

<div class="flex justify-between pb-2">
  <span class="font-semibold">Filters</span>

  @if (hasFilters()) {
    <app-link class="text-sm" (click)="clearFilters()">Clear All</app-link>
  }
</div>
<div class=" border-b border-gray-200 dark:border-gray-700" style="margin-left: -10px; margin-right: -10px"></div>
